import React, { FC } from 'react';
import { SVGProps, setClass } from '@utils';

interface RefreshProps extends SVGProps {
  disabled?: boolean;
}

export const Refresh: FC<RefreshProps> = ({ onClick, disabled, divClassName }) => (
  <div 
    className={setClass(onClick && 'clickable', 'svg') + divClassName}
    onClick={onClick}
  >
    <svg 
      width="11" 
      height="12" 
      viewBox="0 0 11 12" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M9.26618 2.23341C8.29952 1.26675 6.97285 0.666748 5.49952 0.666748C2.55285 0.666748 0.172852 3.05341 0.172852 6.00008C0.172852 8.94675 2.55285 11.3334 5.49952 11.3334C7.98619 11.3334 10.0595 9.63341 10.6529 7.33341H9.26618C8.71952 8.88675 7.23952 10.0001 5.49952 10.0001C3.29285 10.0001 1.49952 8.20675 1.49952 6.00008C1.49952 3.79341 3.29285 2.00008 5.49952 2.00008C6.60618 2.00008 7.59285 2.46008 8.31285 3.18675L6.16618 5.33341H10.8329V0.666748L9.26618 2.23341Z" 
        fill={disabled ? "#C3C7CC" :"#3273E1"}
      />
    </svg>
  </div>
);
